import React from "react"
import loader from "./loader.gif"

const Loader = () => {
    return (
        <img style={{ maxHeight: "200px" }} src={loader} alt="Loading..." />
    )
}

export default Loader